export const isProduction = () => !!(process?.env?.ENV && process.env.ENV.toLowerCase() === 'production');
export const isQa = () => !!(process?.env?.ENV && process.env.ENV.toLowerCase() === 'qa');
export const isNodeDevelopment = () => !!(process?.env?.NODE_ENV?.toLowerCase() === 'development');
export const isHideBaseLogsMode = () =>
  !!(process?.env?.HIDE_BASE_LOGS && process.env.HIDE_BASE_LOGS.toLowerCase() === 'true');
